module.exports = __webpack_public_path__ + "fonts/fontello.804f181b.ttf";